module.exports = __webpack_public_path__ + "static/media/gas-pump.56fbc3bd.svg";